/*
*
*  Core
*
*/
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { App } from './app.component';

/*
*
*  Plugins
*
*/
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { Keyboard } from '@ionic-native/keyboard';
import { AppVersion } from '@ionic-native/app-version';
import { Market } from '@ionic-native/market';
import { Zeroconf } from '@ionic-native/zeroconf';
import { Insomnia } from '@ionic-native/insomnia';
import { Network } from '@ionic-native/network';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { File } from '@ionic-native/file';
import { FileTransfer } from '@ionic-native/file-transfer';
import { FileOpener } from '@ionic-native/file-opener';
import { AppAvailability } from '@ionic-native/app-availability';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Deeplinks } from '@ionic-native/deeplinks';
import { Clipboard } from '@ionic-native/clipboard';


/*
*
*   App structure
*
*/
import { TabsMain } from '../pages/tabsmain/tabsmain';


/*
*
*  Pages App
*
*/
import { Login }         from '../pages/login/login';
import { Categories }    from '../pages/categories/categories';
import { Search }        from '../pages/search/search';
import { Channel }       from '../pages/channel/channel';
import { Application }   from '../pages/application/application';
import { Remote }        from '../pages/remote/remote';
import { Favorite }      from '../pages/favorite/favorite';
import { Account }       from '../pages/account/account';
import { Settings }      from '../pages/settings/settings';
import { Licenses }      from '../pages/licenses/licenses';
import { License }       from '../pages/license/license';
import { Userguide }     from '../pages/userguide/userguide';
import { Logs }          from '../pages/logs/logs';
import { Disconnect }    from '../pages/disconnect/disconnect';

/*
*
*  Providers
*
*/
import { Api }        from '../providers/api/api';
import { Utils }      from '../providers/utils/utils';
import { User }       from '../providers/user/user';
import { IPTV }       from '../providers/iptv/iptv';
import { Fav }        from '../providers/fav/fav';
import { FavApp }     from '../providers/favapp/favapp';
import { Gateway }    from '../providers/gateway/gateway';
import { Deeplink }   from '../providers/deeplink/deeplink';
import { Services }   from '../providers/services/services';

/*
*
*  Components
*
*/
import { EmptyComponent }   from '../components/empty/empty';

@NgModule({
    declarations: [
        App,
        TabsMain,
        Login,
        Categories,
        Search,
        Channel,
        Application,
        Remote,
        Favorite,
        Account,
        Settings,
        Licenses,
        License,
        Userguide,
        Logs,
        Disconnect,
        EmptyComponent
    ],
    imports: [
        IonicModule.forRoot(App, {
            backButtonText: '',
            scrollAssist: false,
            autoFocusAssist: false
        }),
        BrowserModule,
        HttpModule,
        HttpClientModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        App,
        TabsMain,
        Login,
        Categories,
        Search,
        Channel,
        Application,
        Remote,
        Favorite,
        Account,
        Settings,
        Licenses,
        License,
        Userguide,
        Logs,
        Disconnect
    ],
    providers: [
        StatusBar,
        SplashScreen,
        {provide: ErrorHandler, useClass: IonicErrorHandler},
        Keyboard,
        AppVersion,
        Market,
        Zeroconf,
        Insomnia,
        Network,
        ScreenOrientation,
        BarcodeScanner,
        File,
        FileTransfer,
        FileOpener,
        AppAvailability,
        InAppBrowser,
        Deeplinks,
        Clipboard,
        Api,
        Utils,
        User,
        IPTV,
        Fav,
        FavApp,
        Gateway,
        Deeplink,
        Services
    ]
})
export class AppModule {}





// WEBPACK FOOTER //
// ./src/app/app.module.ts